<template>
  <v-dialog :value="value" width="800" persistent>
    <v-card>
      <AdCardTitle dialog>
          {{ modalTitle }}
      </AdCardTitle>

      <v-card-text>
        <v-form ref="form">
          <v-row dense>
            <!-- language -->
            <v-col cols="12">

            </v-col>
            <!-- #text -->
            <v-col cols="12">
              <TextEditor
                v-model="modal.inputs['#text']"
                emitOnInput
              >
                <template #append>
                  <EditableLanguageButton
                    ref="menu"
                    v-model="modal.inputs.language"
                    :locales="projectLocales"
                  />
                </template>
              </TextEditor>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <AdButton type="cancel" @click="closeModal"/>
        <AdButton :type="selected ? 'edit' : 'add'" :disabled="!hasTextContent" @click="save" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { cloneDeep } from 'lodash'
import TextEditor from '../Utilities/TextEditor/TextEditor.vue'

const initialModal = {
  inputs: {
    language: null,
    '#text': null
  }
}
export default {
  components: { TextEditor },
  name: 'AddCommentModal',

  props: {
    // Open/close state of the modal
    value: {
      type: Boolean,
      required: false,
      default: false
    },
    // The selected assertion
    selected: {
      type: Object,
      required: false,
      default: null
    },
    onCancel: {
      type: Function,
      default: null
    }
  },
  data () {
    return {
      modal: cloneDeep(initialModal),
      rules: {
        value: [
          v => !!v || this.$t('required-field'),
          v => v?.trim().length >= 1 || this.$t('invalid-input')
        ]
      }
    }
  },
  computed: {
    hasTextContent () {
      return this.$filters.htmlHasTextContent(this.modal.inputs['#text'])
    },
    modalTitle () {
      const op = this.selected ? 'edit' : 'add'
      return this.$t(`${op}-comment`)
    }
  },
  methods: {
    closeModal () {
      this.modal = cloneDeep(initialModal)
      if (typeof this.onCancel === 'function') {
        this.onCancel()
      }
      this.$emit('input', false)
    },
    save () {
      const newComment = cloneDeep(this.modal.inputs)
      this.$emit('save', newComment)
      this.closeModal()
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (modalIsOpen) {
        if (!modalIsOpen) {
          return
        }
        if (this.selected !== null) {
          this.modal.inputs.language = this.selected.language || null
          this.modal.inputs['#text'] = this.selected['#text'] || null
        }
      }
    }
  }
}
</script>
